import { render, staticRenderFns } from "./CorporateProfile.vue?vue&type=template&id=0c3d6968&"
import script from "./CorporateProfile.vue?vue&type=script&lang=js&"
export * from "./CorporateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports